<template>
  <span class="mr-2">
    {{ programLocal.name }}
  </span>
</template>

<script>

export default {
  name: 'CellRendererProgram',
  computed: {
    programLocal() {
      return this.$store.getters["partner/getProgram"](this.params.value) ? this.$store.getters["partner/getProgram"](this.params.value) : { name: '...' }
    },
  },
}
</script>
